import React, {Fragment, useEffect} from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";
import {FamilyTypes, UserGroupTypes} from "root/DataFunctions/Constants";

const DropdownChildConnections = ( { control, name, mode, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, child_uid, letterbox, isCommunicationsPlan } ) =>
{
    if ( child_uid === undefined || child_uid === null )
    {
        throw new Error ("Invalid Child UiD Passed to DropdownChildConnections") ;
    }

    const canHaveContactPlan = (value) =>
    {
        if ( value.communications_plan_id !== null )
        {
            if ( mode === 'create')
            {
                // This user already has a contact plan with this child
                return false
            }
            else
            {
                // If we're editing, and a plan is in place, we need to allow the users in the list
                return true ;
            }
        }
        else
        {
            if ( +(value.user_type_group) === UserGroupTypes.USER_GROUP_STAFF )
            {
                // Exclude all authority staff
                return false ;
            }
            else
            {
                return true;
            }
        }
    }

    const descriptionForName = ( rec ) =>
    {
        if ( rec.family_type === null )
        {
            return rec.usersname + ' - ' + rec.relationship ;
        }
        else
        {
            if ( +(rec.family_type_id) === FamilyTypes.BIRTH || +(rec.family_type_id) === FamilyTypes.FOREVER || +(rec.family_type_id) === FamilyTypes.FOSTER )
            {
                return rec.usersname + ' - ' + rec.family_type + ' ' + rec.relationship ;
            }
            else
            {
                return rec.usersname + ' - ' + rec.relationship ;
            }
        }
    }

    // Map function used to add a custom data field to the data returned from the database
    // and filter out any records which already have a communications plan in place
    const appendRole = (recArray) =>
    {
        return recArray.filter ((value) =>
        {
            if ( isCommunicationsPlan )
            {
                // This is a dropdown of users to select when creating a communications plan so we need to filter anyone
                // who already has a contact plan with the child

                return canHaveContactPlan(value);
            }
            else if ( letterbox )
            {
                return value.communications_plan_id !== null ;
            }
            else
            {
                return value.communications_plan_id === null && value.user_type_group !== '1' ;
            }
        }).map((rec) =>
            {
                return {
                    ...rec,
                    full_name_and_role: descriptionForName( rec )
                }
            })
    }

    const url = '/child/' + child_uid + '/connections' ;

    const fields = { url: url, keyFieldName: 'ur_id', labelFieldName: 'full_name_and_role', filterFn: appendRole }

    const [ loading, items ] = useListboxFetch( fields ) ;

    // We set the multi flag regardless if the isCommunicatiosnPlan flag is set
    const isReallyMulti = isMulti || isCommunicationsPlan ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isReallyMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownChildConnections;
